import styled from 'styled-components';
import ds from 'designsystem';

const SplashScreenLogo = styled.img`
  margin-top: -${ds.get('metrics.l')};
  margin-left: -${ds.get('metrics.s')};
  max-height: calc(2 * ${ds.get('metrics.xxl')});
`;

export default SplashScreenLogo;



// WEBPACK FOOTER //
// ./src/blocks/SplashScreen/SplashScreenLogo.jsx